import { Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Tooltip,
  IconButton,
  Skeleton,
  Modal,
  Typography,
  Grid,
  Chip } from "@mui/material";
import React, { ReactNode } from "react";
import ModalPopup from "./ModalPopup";
import CloseIcon from '@mui/icons-material/Close';
import { styled } from "@mui/material/styles";
import InfoIcon from "./../../assets/images/icons/info.png";
import Eye from "./../../assets/images/icons/eye.png";
import { toPascalCase } from "../../utils/formatting";
import { formatDate } from "../../utils/dateFormatUtils";
interface CustomPaperProps {
  children: ReactNode;
}
interface TablesProps {
  rows: any;
  onCloseFun: () => void;
  openModal: boolean;
}
const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  boxShadow: "0px 4px 18px rgba(0, 0, 0, 0.07)",
  borderRadius: "6px",
}));

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  padding: "2px",
  color: "#168794",
  fontSize: "12px",
  fontWeight: 600,
  lineHeight: "19px",
  textTransform: "capitalize",
  fontFamily: "Jost",
  textAlign: "left",
  height: "45px",
  width: "200px",
  "&:first-of-type": { paddingLeft: "10px" },
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  padding: "2px",
  color: "#707579",
  fontSize: "12px",
  fontWeight: 500,
  lineHeight: "22px",
  textAlign: "left",
  width: "200px",
  "&:first-of-type": { paddingLeft: "10px" },
}));

const StatusBadge = styled("span")<{
  statusColor: string;
  backgroundColor: string;
}>(({ statusColor, backgroundColor }) => ({
  color: statusColor,
  textTransform: "capitalize",
  backgroundColor,
  textAlign: "left",
  width: "110px",
  padding: "4px 1px",
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: 500,
  border: "none",
  display: "inline-block",
}));
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const ModalViewAction = ({ rows, openModal, onCloseFun }: TablesProps) => {
  return (
    <ModalPopup
        onNavigate={() => { }}
        isOpen={openModal}
        onClose={onCloseFun}
        title=""
        style={{minWidth: "333px",
          minHeight: "320px", }}
      >
        {/* <Box sx={style}> */}
          {/* <Grid container justifyContent="space-between" alignItems="center" mb={2}> */}
            {/* <Typography variant="h6">Disbursement Details</Typography> */}
            {/* <IconButton
              onClick={onCloseFun}
              sx={{
              position: "absolute",
              top: 8,
              right: 8,
              padding: "4px",
              }}
            >
              <CloseIcon />
            </IconButton> */}
          {/* </Grid> */}

          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} sm={4} textAlign="center">
              <Typography variant="subtitle2" sx={{ color: "grey.600" }}>
                Request ID
              </Typography>
              <Typography variant="body2" sx={{ textAlign: "center",fontWeight:'bold' }}>
                {rows?.referenceNumber}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4} textAlign="center">
              <Typography variant="subtitle2" sx={{ color: "grey.600" }}>
                Disbursement Amount
              </Typography>
              <Typography variant="body2" sx={{ textAlign: "center",fontWeight:'bold' }}>
                INR {rows?.disbursedAmount}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={4} textAlign="center">
              <Typography variant="subtitle2" sx={{ color: "grey.600" }}>
                Disbursement Type
              </Typography>
              <Typography variant="body2" sx={{ textAlign: "center",fontWeight:'bold' }}>
                {rows &&
                  rows?.lienValues &&
                  rows?.lienValues.map((item: any) => `${toPascalCase(item.type)}`).join(" + ")}
              </Typography>
            </Grid>
          </Grid>

          <hr/>
          <StyledTableContainer sx={{ border:"3px solid #cdc8c8"}}>
            <TableHead>
              <TableRow>
                <StyledTableCellHead><strong>DISBURSEMENT TYPE</strong></StyledTableCellHead>
                <StyledTableCellHead><strong>AMOUNT</strong></StyledTableCellHead>
                <StyledTableCellHead><strong>STATUS</strong></StyledTableCellHead>
                <StyledTableCellHead><strong>DISBURSEMENT DATE</strong></StyledTableCellHead>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows && rows?.lienValues &&  rows?.lienValues?.map((item:any, index:number) => (
              <TableRow key={index}>
                <StyledTableCellBody>{item.type=="lien"?"Fund Release from Lien A/c":item?.type=="tranche"?"New Tranche":""}</StyledTableCellBody>
                <StyledTableCellBody>INR {item?.amount}</StyledTableCellBody>
                <StyledTableCellBody>
                  <StatusBadge
                    statusColor="#EA5455"
                    backgroundColor={( item?.status==="approved" )
                            ? "#b4ffd5"
                            : item?.status?.toLowerCase()==="pending" || item?.status?.toLowerCase() === "rejected" 
                            ? "rgba(234, 84, 85, 0.2)"
                            :rows?.status === "query"
                            ? "#eaeaea"
                            : "rgba(8, 7, 7, 0.2)"
                    }
                  >
                    <span
                      style={{
                    color: ( item?.status==="approved")
                        ? "#28C76F"
                        : item?.status?.toLowerCase() === "pending" 
                        ? "#EA5455"
                        :rows?.status === "query"
                        ? "rgb(28, 177, 177)"
                        : "#EA5455",
                        textTransform: "capitalize",
                        marginLeft: "8px",
                      }}
                    >
                       {item.status}
                      </span>
                      {item?.status?.toLowerCase()=="pending"  && 
                      <Tooltip title={item?.BankUploadStatus ?item?.BankUploadStatus:"Pending From Avanse"} enterTouchDelay={50} placement="top">
                        <img
                          src={InfoIcon}
                          alt="Status"
                          style={{
                            height: "15px",
                            width: "15px",
                            position: "relative",
                            left: "56%",
                          }}
                        />
                      </Tooltip>}
                      {item.type==="lien" && ((item?.status?.toLowerCase()=="rejected" ) &&  item?.remark?.length>0 && (item?.remark?.filter((rem:any)=>rem?.remark!=rows?.remark && rows?.remark!="")[0]?.remark || item?.remark?.length==1))
                         &&
                          <Tooltip
                            title={ item?.remark?.length==1?rows?.remark:item?.remark?.filter((rem:any)=>rem?.remark!=rows?.remark && rows?.remark!="")[0]?.remark}
                            enterTouchDelay={50}
                            placement="top"
                          >
                            <img
                              src={InfoIcon}
                              alt="Status"
                              style={{
                                height: "15px",
                                width: "15px",
                                position: "relative",
                                left: "56%",
                              }}
                            />
                          </Tooltip>
                         }
                         {
                          (item.type==="tranche" && item?.status?.toLowerCase()==="rejected") &&
                         
                          <Tooltip
                            title={rows?.remark}
                            enterTouchDelay={50}
                            placement="top"
                          >
                            <img
                              src={InfoIcon}
                              alt="Status"
                              style={{
                                height: "15px",
                                width: "15px",
                                position: "relative",
                                left: "56%",
                              }}
                            />
                          </Tooltip>
                         }
                  </StatusBadge>
                </StyledTableCellBody>
                <StyledTableCellBody>{item.type==="tranche" && rows?.disbursemntDate ? formatDate(rows?.disbursemntDate) : item?.disbDate ? formatDate(item?.disbDate):""}</StyledTableCellBody>
              </TableRow>
              ))}
            </TableBody>
          </StyledTableContainer>
          <hr/>
          <Box mt={2} display="flex" justifyContent="center" alignItems="center" gap={4}>
            {/* Another Section */}
            <Typography variant="subtitle2" sx={{ fontWeight: "bold" }}>
              Final Disbursed Amount: 
              {
                rows?.lienValues
                ?.filter((item: any) => item.status === "approved")
                .reduce((sum: any, item: any) => sum + Number(item.amount), 0) === 0
                ? " NA"
                : ` INR ${rows?.lienValues
                    ?.filter((item: any) => item.status === "approved")
                    .reduce((sum: any, item: any) => sum + Number(item.amount), 0)}`
              }
            </Typography>
          </Box>

        {/* </Box> */}
      </ModalPopup>
  );
};

export default ModalViewAction;
